import html2pdf from "html2pdf.js";

export const convertSVGToBase64 = async (imageElementId, imageStr) => {
  // Fetch the SVG content asynchronously
  // const response = await fetch("http://localhost:8080/img/racecourse-vaal-turf-1400.e399fae0.svg");
  const response = await fetch(imageStr);
  // Check if the response is okay
  if (!response.ok) {
    throw new Error("Failed to load SVG");
  }
  // Read the SVG content as text
  const svgText = await response.text();

  // Create a new image element
  const img = new Image();

  // Base64 encode the SVG text
  const base64EncodedSVG = btoa(svgText);

  img.src = `data:image/svg+xml;base64,${base64EncodedSVG}`;

  // Wait for the image to load
  await new Promise((resolve) => {
    img.onload = resolve;
  });

  // Create a canvas element
  const canvas = document.createElement("canvas");
  canvas.width = img.width; // Set the canvas width to the image width
  canvas.height = img.height; // Set the canvas height to the image height

  // Draw the SVG image onto the canvas
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0);

  // Convert the canvas content to a PNG data URL
  const pngDataUrl = canvas.toDataURL("image/png");

  // Get the Base64 string from the PNG data URL
  const base64Png = pngDataUrl.split(",")[1]; // Split to get the base64 part
  document.getElementById(
    imageElementId,
  ).src = `data:image/png;base64,${base64Png}`;
};

export const ExportHTMLtoPDF = (HTML) => {
  // Reference the content you want to export

  let opt = {
    margin: 1,
    filename: "PDF Export.pdf",
    image: { type: "jpeg", quality: 2 },
    html2canvas: {
      scale: 2,
      allowTaint: false,
      useCORS: true,
    },
    jsPDF: {
      unit: "px",
      format: "a3",
      orientation: "landscape",
      hotfixes: ["px_scaling"],
    },
    pagebreak: {
      mode: ["avoid-all", "css", "legacy"],
    },
    allowTaint: false,
    useCORS: true,
  };
  // Call html2pdf
  html2pdf().set(opt).from(HTML).toPdf().save();
};

const convertImageToBase64 = (url, callback) => {
  // Create a new image element
  const img = new Image();
  img.crossOrigin = "Anonymous"; // Make sure to enable CORS if necessary
  img.src = url;

  img.onload = function () {
    // Create a canvas element
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    // Set canvas dimensions to the image dimensions
    canvas.width = img.width;
    canvas.height = img.height;

    // Draw the image onto the canvas
    ctx.drawImage(img, 0, 0);

    // Get the data URL (Base64 encoded string)
    const dataURL = canvas.toDataURL("image/jpeg"); // or 'image/png'
    // Call the callback with the Base64 string
    callback(dataURL);
  };

  img.onerror = function (error) {
    console.error("Image loading failed:", error);
  };
};

export const getSVGContent = async (imgElement) => {
  const imgSrc = imgElement.getAttribute("src");
  fetch(imgSrc)
    .then((response) => response.text())
    .then((svgContent) => {
      // Create a temporary DOM element to hold the SVG content
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = svgContent;

      // Extract the actual <svg> element from the response
      const svgElement = tempDiv.querySelector("svg");

      if (svgElement) {
        // Replace img with the inline SVG
        imgElement.parentNode.replaceChild(svgElement, imgElement);
      }

      return tempDiv;
    })
    .catch((error) => console.error("Error fetching the SVG:", error));
};

export const fetchImage = async (
  imagePath,
  fileType = "svg",
  defaultRaceCoursePath,
  element,
) => {
  let src = "";
  if (this.isDurbanJulyTurfRaces()) {
    imagePath = imagePath.replace(
      "racecourse-greyville-poly",
      "racecourse-greyville-turf",
    );
  }
  try {
    const t = require("../assets/images/" + imagePath + "." + fileType);
    if (imagePath && defaultRaceCoursePath) {
      if (t.slice(-3) === "svg") {
        return await convertSVGToBase64("raceCardCourse");
      }
    }
  } catch (e) {
    return require("../assets/images/" +
      defaultRaceCoursePath +
      "." +
      fileType);
  }
};
